import React from "react";
import { Locale } from "../../config";
import { Img } from "./Img";

export const SolarReferences = ({ locale }: { locale: Locale }) => {
    return (
        <div className="flex gap-8 w-fit justify-center flex-wrap">
            {locale === "FR-FR" && (
                <>
                    <div className="flex items-center justify-center">
                        <Img
                            size="xs"
                            alt=""
                            className="h-[24px]"
                            src="/pages/de-de/industry/solar/references/fr/echomEnergies.png"
                        />
                    </div>
                    <div className="flex items-center justify-center">
                        <Img
                            size="xs"
                            alt=""
                            className="h-[24px]"
                            src="/pages/de-de/industry/solar/references/fr/adopteSolaire.png"
                        />
                    </div>
                    <div className="flex items-center justify-center">
                        <Img
                            size="xs"
                            alt=""
                            className="h-[24px]"
                            src="/pages/de-de/industry/solar/references/fr/dabroElectric.png"
                        />
                    </div>
                    <div className="flex items-center justify-center">
                        <Img
                            size="xs"
                            alt=""
                            className="h-[24px]"
                            src="/pages/de-de/industry/solar/references/fr/groupeEnergie.jpg"
                        />
                    </div>
                    <div className="flex items-center justify-center">
                        <Img
                            size="xs"
                            alt=""
                            className="h-[24px]"
                            src="/pages/de-de/industry/solar/references/fr/sunnytech.png"
                        />
                    </div>
                </>
            )}

            <div className="flex items-center justify-center">
                <Img
                    size="xs"
                    alt=""
                    className="h-[24px]"
                    src="/pages/de-de/industry/dealerships/references/lichtblick.svg"
                />
            </div>

            <div className="flex items-center justify-center">
                <Img
                    size="xs"
                    alt=""
                    className="h-[25px] -mt-0"
                    src="/pages/de-de/industry/solar/references/svea_logo.png"
                />
            </div>

            <div className="flex items-center justify-center">
                <Img
                    size="xs"
                    sizeMobile="xs"
                    alt=""
                    className="h-[60px] -mr-4"
                    src="/pages/de-de/industry/solar/references/gasag.png"
                />
            </div>

            <div className="flex items-center justify-center">
                <Img
                    size="xs"
                    sizeMobile="xxs"
                    alt=""
                    className="h-[23px]"
                    src="/pages/de-de/industry/solar/references/New_logo.svg.png"
                />
            </div>

            {locale !== "FR-FR" && (
                <>
                    <div className="flex items-center justify-center">
                        <Img
                            size="xs"
                            sizeMobile="xxs"
                            alt=""
                            className="h-[30px]"
                            src="/pages/de-de/industry/solar/references/pvgreen-logo.svg"
                        />
                    </div>

                    <div className="flex items-center justify-center">
                        <Img
                            size="xxs"
                            alt=""
                            className="h-[30px] -mr-2"
                            src="/pages/de-de/industry/dealerships/references/invanova.png"
                        />
                    </div>

                    <div className="flex items-center justify-center">
                        <Img
                            size="xs"
                            alt=""
                            className="h-[20px] -mt-3"
                            src="/pages/de-de/industry/dealerships/references/solareins.svg"
                        />
                    </div>
                    <div className="flex items-center justify-center">
                        <Img
                            size="xs"
                            alt=""
                            className="h-[70px] -mt-1"
                            src="/pages/de-de/industry/solar/references/calosol_logo.webp"
                        />
                    </div>
                    <div className="flex items-center justify-center">
                        <Img
                            size="xs"
                            alt=""
                            className="h-[25px] -mt-2"
                            src="/pages/de-de/industry/solar/references/swb.png"
                        />
                    </div>
                </>
            )}
        </div>
    );
};
